module.exports = __webpack_public_path__ + "8edaea292cec0effbc6089daa4e1a8c7.png";